import { CommonModule } from '@angular/common';
import {
    Component,
    OnInit,
    ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import {
    MatAutocompleteModule,
    MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatInput, MatInputModule } from '@angular/material/input';
import { Observable, debounceTime, startWith, switchMap } from 'rxjs';
import { ErrorStateMatcher } from '@angular/material/core';
import { SalesOfferRuleType } from '@zopup/zop-types';

@Component({
    selector: 'zop-autocomplete',
    imports: [
        CommonModule,
        FormlyModule,
        ReactiveFormsModule,
        FormsModule,
        MatAutocompleteModule,
        MatInputModule,
    ],
    template: `
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>
                {{ to.label }}
                <span *ngIf="to.required" class="mat-form-field-required-marker"> *</span>
            </mat-label>
            <input
                matInput
                [matAutocomplete]="auto"
                [formControl]="formControl"
                [formlyAttributes]="field"
                [errorStateMatcher]="errorStateMatcher"
            />
            <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn.bind(this)"
                (optionSelected)="onSelectionChange($event)"
            >
                <mat-option *ngFor="let item of items | async" [value]="item">
                    {{ item.label }}
                </mat-option>
            </mat-autocomplete>

            <mat-error *ngIf="showError">
                <formly-validation-message [field]="field"></formly-validation-message>
            </mat-error>
        </mat-form-field>
    `,
    styles: [
        `
            .full-width {
                width: 100%;
            }
            mat-form-field {
                display: flex;
                flex-direction: column;
            }
        `,
    ]
})
export class ZopAutoCompleteComponent
    extends FieldType<FieldTypeConfig>
    implements OnInit
{
    @ViewChild(MatInput) formFieldControl!: MatInput;
    @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;
    items?: Observable<
        {
            label: string;
            value: string;
            id: string;
            type: SalesOfferRuleType;
        }[]
    >;
    errorStateMatcher!: ErrorStateMatcher;
    customerSelected: any;

    ngOnInit() {
        this.items = this.formControl.valueChanges.pipe(
            startWith(this.formControl.value || ''),
            debounceTime(200),
            switchMap((term) => {
                if (this.props?.['filter'] && typeof this.props['filter'] === 'function') {
                    return this.props['filter'](term) as Observable<
                        AutocompleteData[]
                    >;
                }
                return [] as unknown as Observable<AutocompleteData[]>;
            })
        );

        // this.items = this.props.options as Observable<AutocompleteData[]>;
    }


    displayFn(item: any): string {
        return item && item.label ? item.label : '';
    }

    onSelectionChange(event: any) {
        const selectedValue = event.option.value;
        this.formControl.setValue(selectedValue);
        this.customerSelected = selectedValue;
    }
}

export interface AutocompleteData {
    label: string;
    value: any;
    id: string;
    type: SalesOfferRuleType;
    extra?: any;
}
